// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout--1aA1b"};